/*remove the Collections widget span tag added by hoolah lib*/

/**
 * This function sets up a MutationObserver to watch for and remove
 * any Hoolah/ShopBack payment taglines that are dynamically injected
 * into the page.
 */
function setupHoolahObserver() {
    // The 'body' is a reliable parent that exists early. We will watch it for changes.
    const targetNode = document.body;
 
    // Create an observer instance linked to a callback function.
    const observer = new MutationObserver((mutationsList) => {
        // Look through all mutations that just occurred.
        for (const mutation of mutationsList) {
            // We only care about nodes being added.
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach(node => {
                    // We only care about element nodes.
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const parentSelector = 'div.t4s-product div.t4s-product-wrapper div.t4s-product-info div.t4s-product-info__inner';

                        // Case 1: The added node is the hoolah span itself.
                        /*
                        if (node.matches('span.hoolah_text_1')) {
                            // Check if its parent matches the required structure.
                            if (node.closest(parentSelector)) {
                                node.remove();
                            }
                        }
                        */
                        // Case 2: A larger element containing the span is added.
                        // Find all hoolah spans within that new element that are also inside the correct parent structure.
                        const hoolahSpans = node.querySelectorAll(`${parentSelector} span.hoolah_text_1`);
                        hoolahSpans.forEach(span => {
                            span.remove();
                        });
                    }
                });
            }
        }
    });
 
    // Start observing the target node for configured mutations.
    observer.observe(targetNode, { childList: true, subtree: true });
}
 
// Run the observer setup function as soon as the page is ready.
"loading" !== document.readyState ? setupHoolahObserver() : document.addEventListener("DOMContentLoaded", setupHoolahObserver);